<div class="checkbox-container">

    <!-- Accordion for each group -->
    <mat-accordion multi>
        @for (groupTitle of jobTitles | searchFilter:searchText:groupedItems; track idx; let idx = $index) {
        <mat-expansion-panel [expanded]="searchText ? isGroupMatch(groupTitle) : groupExpanded[groupTitle]" class="no-padding-panel">
            <mat-expansion-panel-header (click)="toggleExpand(groupTitle)" onKeyDown="">
                <div class="group-select-btn" [class.active]="groupAllSelected[groupTitle]"
                    (click)="onGroupSelectClick(groupTitle); $event.stopPropagation()" onKeyDown="">
                    <i [class]="groupAllSelected[groupTitle] ? 'fa-solid fa-square-check' : 'fa-regular fa-square'"
                        [class.hint-pulse]="!groupAllSelected[groupTitle]"></i>
                    <span>Select All {{ groupTitle | camelCase }} {{getSelectedCount(groupTitle)}}</span>
                </div>
            </mat-expansion-panel-header>

            <div class="group-content">
                @for (item of groupedItems[groupTitle] | searchFilter:searchText:groupTitle; track idx1; let idx1 = $index) {
                <div class="checkbox-item" [class.selected]="item.selected"
                    (click)="onItemClick(item, groupTitle)" onKeyDown="">
                    <i [class]="item.selected ? 'fa-solid fa-square-check' : 'fa-regular fa-square'"
                        [class.hint-pulse]="!item.selected"></i>
                    <span [innerHTML]="item.fieldLabel | uppercase | highlight:searchText"></span>
                </div>
                }
            </div>
        </mat-expansion-panel>
        }
    </mat-accordion>
</div>